// extracted by mini-css-extract-plugin
module.exports = {"api-route":"api-route_api-route__zI0q0","api-route__method":"api-route_api-route__method__h_74w","deprecated":"api-route_deprecated__PfeC2"};